module.exports = __webpack_public_path__ + "static/media/growth.e22431b6.svg";